import { createFileRoute } from '@tanstack/react-router'
import { AdminRiley } from '../features/admin'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/riley')({
  ...adminRouteState,
  component: AdminRiley,
})
